module.exports = __webpack_public_path__ + "static/media/P2_Tip_Box.4ac1c4af.svg";